
import {filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Utility } from '../shared/utility/utility'
import { Observable } from 'rxjs';
import { EmitterService } from './emitter.service'


@Injectable()
export class AuthGuard  {
    langCode;
    queryParams;
    routerEvent;
    constructor(private utils: Utility,
        private router: Router,
        private emitterService: EmitterService,
        private activeRoute: ActivatedRoute) {
        this.langCode = localStorage.getItem('langCode');
        this.routerEvent = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e) => {
            this.queryParams = this.activeRoute.snapshot.queryParams;
        })

    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.utils.isUserLoggedIn()) {
            if (window.location.pathname.includes('login') || window.location.pathname.includes('register')) {
                this.router.navigate([this.langCode]);
            }
            return true;
        } else {
            let params = {};
            if (window.location.search) {
                params = JSON.parse('{"' + decodeURI(window.location.search.substring(1).replace(/&/g, "\",\"").replace(/=/g, "\":\"")) + '"}')
            }

            this.router.navigate([this.langCode + "/login"], { queryParams: params });
            return false;
        }
    }


    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.utils.isUserLoggedIn()) {
            return true;
        }
        else {
            this.router.navigate([this.langCode + "/login"], { queryParams: this.queryParams });
            return false;
        }
    }

    canActivatewithParams(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.utils.isUserLoggedIn()) {
            return true;
        }
        else {
            this.router.navigate([this.langCode + "/login"], { queryParams: this.queryParams });
            return false;
        }
    }


    // canRedirectToDeposit(){
    //   if(window.location.search.length > 0 && window.location.pathname.includes('deposit')){

    //   }
    // }

}
